export const INVITE_STAFF_FAILURE = 'INVITE_STAFF_FAILURE';
export const INVITE_STAFF_REQUEST = 'INVITE_STAFF_REQUEST';
export const INVITE_STAFF_SUCCESS = 'INVITE_STAFF_SUCCESS';

export const STAFF_LIST_REQUEST = 'STAFF_LIST_REQUEST';
export const STAFF_LIST_SUCCESS = 'STAFF_LIST_SUCCESS';
export const STAFF_LIST_FAILURE = 'STAFF_LIST_FAILURE';

export const REMOVE_STAFF_FAILURE = 'REMOVE_STAFF_FAILURE';
export const REMOVE_STAFF_REQUEST = 'REMOVE_STAFF_REQUEST';
export const REMOVE_STAFF_SUCCESS = 'REMOVE_STAFF_SUCCESS';

export const VERIFY_STAFF_INVITATION_FAILURE = 'VERIFY_STAFF_INVITATION_FAILURE';
export const VERIFY_STAFF_INVITATION_REQUEST = 'VERIFY_STAFF_INVITATION_REQUEST';
export const VERIFY_STAFF_INVITATION_SUCCESS = 'VERIFY_STAFF_INVITATION_SUCCESS';